export default __webpack_public_path__ + "static/screenThirdSectionUkBig-a36bed530fd6e62c8712c9fe93a6e51b.webp";